module.exports = __webpack_public_path__ + "img/supervisor.a1f16b25.svg";